<app-header></app-header>
@if (loadingLazyModule) {
  <div class="site-loader-wrapper grey-bg-loader">
    <div class="loader"></div>
  </div>
}
<router-outlet (activate)="componentAdded($event)"></router-outlet>
<app-footer></app-footer>
